/* LGB Elite "Build your greenhouse" panel (18 Oct 2026).
   For the Elite models sold as a basic model (Supreme, Classique, Titan 1000, Titan 1200),
   offers the structural options from Elite's price list: base, bar capping, hybrid panels,
   extra rear doors and a partition. Prices come from a hidden "<model> Build Options"
   product (Option / Size / Finish), so they always match the size, glass and finish chosen.
   The ticked options go into the basket with the greenhouse via assets/lgb-elite-addons.js,
   which reads window.LGBEliteBuildPicks(). Nothing is ever pre-ticked. */
(function () {
  var CFG = window.LGBEliteBuild;
  if (!CFG || !CFG.productHandle || !CFG.optionsHandle) return;

  var product = null, opts = null, lastKey = null;
  var on = {}; /* ticked keys */

  function money(c) {
    var d = (c % 100 === 0) ? 0 : 2;
    return '£' + (c / 100).toLocaleString('en-GB', { minimumFractionDigits: d, maximumFractionDigits: d });
  }
  function esc(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function mainForm() { return document.querySelector('form[data-type="add-to-cart-form"]'); }
  function names(p) { return (p.options || []).map(function (o) { return typeof o === 'string' ? o : (o && o.name) || ''; }); }
  function current() {
    var f = mainForm(), inp = f && f.querySelector('input[name="id"]');
    if (!inp || !product) return null;
    var hit = null;
    product.variants.forEach(function (v) { if (String(v.id) === String(inp.value)) hit = v; });
    return hit;
  }
  function opt(v, name) {
    var i = names(product).indexOf(name);
    return i < 0 || !v ? null : [v.option1, v.option2, v.option3][i];
  }
  function find(option, size, finish) {
    var hit = null;
    opts.variants.forEach(function (v) {
      if (!hit && v.option1 === option && v.option2 === size && v.option3 === finish && v.available !== false) hit = v;
    });
    return hit;
  }

  /* Generic models (Edge, Thyme, Zenith, Kensington, Easygrow, K800, Windsor, dwarf walls):
     every Option in the options product that exists for this size + finish becomes a row.
     "Name - <Glazing>" rows only show for that glazing. Bar capping never shows with horticultural glass. */
  var NOTES = [
    [/integral base/i, "Elite's own aluminium base, with the doors dropped to ground level for a level step in."],
    [/dropped into/i, "The door is dropped down into your base so there is no step up."],
    [/base plinth/i, "Elite's 5\" tall aluminium base for the greenhouse to sit on."],
    [/bar capping/i, 'Coloured caps over every glazing bar for a neater finish. Toughened glass or polycarbonate only.'],
    [/hybrid/i, 'Solid coloured panels around the lower sides instead of glass.'],
    [/partition/i, 'Splits the greenhouse into two rooms, with its own door.'],
    [/extra (double )?door/i, 'An extra door - let us know where you would like it when you order.'],
    [/soft soil/i, 'Extra support for the base on soft ground.']
  ];
  function genericRows(gv) {
    var size = opt(gv, 'Size'), fin = opt(gv, 'Finish') || 'Aluminium Finish', glass = opt(gv, 'Glazing');
    var seen = {}, out = [];
    opts.variants.forEach(function (v) {
      var name = v.option1;
      if (/ for /.test(name)) return; /* add-ons for other options - see companions() */
      if (seen[name] || v.available === false || v.option3 !== fin) return;
      if (v.option2 !== size && v.option2 !== 'All sizes') return;
      var title = name, m = name.match(/^(.*) - (.+)$/);
      if (m) { if (!glass || m[2] !== glass) return; title = m[1]; }
      if (/bar capping/i.test(name) && glass && /horticultural/i.test(glass)) return;
      seen[name] = 1;
      var note = '';
      NOTES.forEach(function (n) { if (!note && n[0].test(name)) note = n[1]; });
      out.push({ key: title.toLowerCase().replace(/[^a-z]/g, '').slice(0, 24), title: title, note: note, v: v, group: '' });
    });
    return out;
  }

  /* Add-ons that Elite prices only when two options are chosen together, e.g. "Bar capping for partition"
     (named "<option> for <other option>"). They appear, already ticked, once both are ticked. */
  function companions(gv, list) {
    var size = opt(gv, 'Size'), fin = opt(gv, 'Finish') || 'Aluminium Finish';
    var ticked = list.filter(function (r) { return on[r.key]; }).map(function (r) { return r.title.toLowerCase(); });
    var seen = {}, out = [];
    opts.variants.forEach(function (v) {
      var name = v.option1, m = name.match(/^(.+) for (.+)$/);
      if (!m || seen[name] || v.available === false || v.option3 !== fin) return;
      if (v.option2 !== size && v.option2 !== 'All sizes') return;
      var a = m[1].toLowerCase(), b = m[2].toLowerCase();
      var hasA = ticked.some(function (t) { return t.indexOf(a) === 0; });
      var hasB = ticked.some(function (t) { return t.indexOf(a) !== 0 && t.indexOf(b) !== -1; });
      if (!hasA || !hasB) return;
      seen[name] = 1;
      out.push({ key: 'c' + name.toLowerCase().replace(/[^a-z]/g, '').slice(0, 30), title: name, auto: true, v: v, group: '',
        note: 'Added because you have chosen both - Elite price this separately.' });
    });
    return out;
  }

  /* Work out every row for the chosen greenhouse. Returns [{key, title, note, v, group}] */
  function rows(gv) {
    if (CFG.generic) return genericRows(gv);
    var size = opt(gv, 'Size'), fin = opt(gv, 'Finish') || 'Aluminium Finish';
    var glass = opt(gv, 'Glazing'); /* Supreme / Classique only - Titans are toughened as standard */
    var out = [];
    function add(key, title, note, v, group) { if (v) out.push({ key: key, title: title, note: note, v: v, group: group || '' }); }

    add('bib', 'Integral base with dropped doors',
      "Elite's own aluminium base, with the doors dropped to ground level for a level step in.",
      find('Integral base with dropped doors', size, fin), 'base');
    add('brick', 'Doors dropped into your own brick base',
      "Building your own brick or dwarf wall base to Elite's spec? The doors are dropped down into it so there is no step.",
      find('Doors dropped into your brick base', 'All sizes', fin), 'base');

    var barOk = CFG.barCapping && glass && !/horticultural/i.test(glass);
    if (barOk) add('bar', 'Bar capping',
      'Coloured caps over every glazing bar for a neater finish. Toughened glass or polycarbonate only.',
      find('Bar capping', size, fin));
    if (CFG.barCapping && !barOk) delete on.bar;

    add('hybrid', 'Hybrid panels',
      'Solid coloured panels around the lower sides instead of glass.',
      find('Hybrid panels', size, fin));

    var rear = (barOk && on.bar && find('Extra double doors in the rear end, bar capped', 'All sizes', fin)) ||
      find('Extra double doors in the rear end', 'All sizes', fin);
    add('rear', 'Extra double doors in the rear end', 'A second set of double doors at the other end.', rear);

    var g = CFG.barCapping ? glass : 'Toughened';
    var part = g && (on.bib && find('Partition with double doors - ' + g + ', integral base', 'All sizes', fin) ||
      find('Partition with double doors - ' + g, 'All sizes', fin));
    add('part', 'Partition with double doors',
      'Splits the greenhouse into two rooms with a glazed wall and its own double doors.' + (on.bib ? ' Includes the base section.' : ''), part);
    return out;
  }

  function render() {
    var f = mainForm();
    if (!f || !product || !opts) return;
    var gv = current();
    if (!gv) return;
    var list = rows(gv);
    var have = {};
    list.forEach(function (r) { have[r.key] = 1; });
    Object.keys(on).forEach(function (k) { if (!have[k]) delete on[k]; });
    list = list.concat(companions(gv, list));

    var key = gv.id + '|' + list.map(function (r) { return r.key + r.v.id + (on[r.key] ? 1 : 0); }).join(',');
    var box = document.getElementById('lgbEliteBuild');
    if (box && key === lastKey && f.contains(box)) return;
    if (!list.length) { if (box) box.remove(); lastKey = null; return; }

    var powder = /powder/i.test(opt(gv, 'Finish') || '');
    var html = '<div class="lgb-adds__head">Build your greenhouse</div>';
    list.forEach(function (r) {
      var ticked = r.auto || on[r.key];
      html += '<div class="lgb-adds__row' + (ticked ? ' is-on' : '') + '" data-row="' + r.key + '">' +
        '<input type="checkbox" id="lgbBuild_' + r.key + '"' + (ticked ? ' checked' : '') + (r.auto ? ' disabled' : '') + '>' +
        '<label class="lgb-adds__label" for="lgbBuild_' + r.key + '">' + esc(r.title) +
          '<span class="lgb-adds__note">' + esc(r.note + (powder ? ' Powder coated to match.' : '')) + '</span>' +
        '</label>' +
        '<span class="lgb-adds__price">+' + money(r.v.price) + '</span>' +
      '</div>';
    });
    html += '<div class="lgb-adds__status" id="lgbBuildStatus"></div>';

    var nb = document.createElement('div');
    nb.className = 'lgb-adds lgb-build';
    nb.id = 'lgbEliteBuild';
    nb.innerHTML = html;
    list.forEach(function (r) {
      nb.setAttribute('data-' + r.key, r.v.id);
      nb.setAttribute('data-group-' + r.key, r.group);
    });
    nb.addEventListener('change', function (e) {
      var row = e.target.closest ? e.target.closest('.lgb-adds__row') : null;
      if (!row) return;
      var k = row.getAttribute('data-row');
      if (e.target.checked) {
        on[k] = true;
        /* base choices are one or the other */
        if (k === 'bib') delete on.brick;
        if (k === 'brick') delete on.bib;
      } else delete on[k];
      lastKey = null;
      render();
    });

    if (box) box.replaceWith(nb);
    else {
      var extras = document.getElementById('lgbAddons');
      var buttons = f.querySelector('.product-form-buttons');
      if (extras && extras.parentNode) extras.parentNode.insertBefore(nb, extras);
      else if (buttons && buttons.parentNode) buttons.parentNode.insertBefore(nb, buttons);
      else f.appendChild(nb);
    }
    lastKey = key;
  }

  /* Read by the extras engine when the customer adds to basket. */
  window.LGBEliteBuildPicks = function () {
    var box = document.getElementById('lgbEliteBuild');
    if (!box) return [];
    var gv = current();
    var powder = /powder/i.test(opt(gv, 'Finish') || '');
    var out = [];
    box.querySelectorAll('input[type=checkbox]:checked').forEach(function (cb) {
      var k = cb.closest('[data-row]').getAttribute('data-row');
      var id = box.getAttribute('data-' + k);
      if (id) out.push({ id: id, pc: powder });
    });
    return out;
  };

  function load(h) {
    return fetch('/products/' + h + '.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function start() {
    Promise.all([load(CFG.productHandle), load(CFG.optionsHandle)]).then(function (res) {
      product = res[0]; opts = res[1];
      if (!product || !opts || !opts.variants) return;
      render();
      setInterval(render, 400);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
